import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { db } from '../lib/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { initWorksPage } from '../assets/js/slater';
import Footer from '../components/Footer';

const WorksPage = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPortfolios = async () => {
      try {
        setIsLoading(true);
        const portfoliosRef = collection(db, 'portfolios');
        const q = query(portfoliosRef, where('is_published', '==', true));
        const querySnapshot = await getDocs(q);
        const portfolioList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // Sort on the client-side to avoid needing a composite index
        portfolioList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        
        setPortfolios(portfolioList);
      } catch (err) {
        console.error("Error fetching portfolios: ", err);
        setError("포트폴리오를 불러오는 데 실패했습니다.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchPortfolios();
  }, []);

  useEffect(() => {
    if (isLoading) return;

    // Update body class for this page
    document.body.setAttribute('data-barba-namespace', 'works');
    document.body.setAttribute('data-barba', 'container');
    
    // Function to initialize works page animations
    const initializeWorksPage = () => {
      // Check if required DOM elements exist
      const worksPage = document.querySelector('[data-barba-namespace="works"]');
      const horizontalSection = document.querySelector("[data-horizontal-section]");
      const wrapper = document.querySelector("[data-horizontal-wrap]");
      
      if (worksPage && horizontalSection && wrapper) {
        try {
          // Add hide-scrollbar class to html element
          document.documentElement.classList.add("hide-scrollbar");
          
          // Initialize the works page animations
          initWorksPage();
          
          console.log('Works page initialized successfully');
        } catch (error) {
          console.error('Error initializing works page:', error);
        }
      } else {
        console.warn('Required DOM elements not found for works page initialization');
        // Retry after a short delay
        setTimeout(initializeWorksPage, 100);
      }
    };
    
    // Initialize after a short delay to ensure DOM is ready
    const initTimer = setTimeout(initializeWorksPage, 50);
    
    // Cleanup function
    return () => {
      document.body.removeAttribute('data-barba-namespace');
      document.body.removeAttribute('data-barba');
      document.documentElement.classList.remove("hide-scrollbar");
      clearTimeout(initTimer);
    };
  }, [isLoading]);

  const renderPortfolioItems = (mobile = false) => {
    if (isLoading) {
      return <div className="p-10 text-center"></div>;
    }

    if (error) {
      return <div className="p-10 text-center text-red-500">{error}</div>;
    }

    if (portfolios.length === 0) {
      return <div className="p-10 text-center">No works found.</div>;
    }

    return portfolios.map(portfolio => (
      <div key={portfolio.id} role="listitem" data-horizontal-item="" data-filter-name={portfolio.style || 'renovations-extensions'} data-filter-status="active" className={`hero_works_item u-flex-noshrink w-dyn-item ${mobile ? 'is-mobile' : ''}`}>
        <Link aria-label={portfolio.title} to={`/project/${portfolio.id}`} className="hero_works_link w-inline-block">
          <div data-image-transition-anim="" data-orientation="portrait" data-clip-container="" className="hero_list_image_container u-position-relative">
            <div data-image-cover="" className="g_image_cover"></div>
            <img width="Auto" height="Auto" src={portfolio.thumbnail_url} loading="eager" alt={`${portfolio.title} project`} data-image="" className="hero_list_image" />
          </div>
          <div className="hero_list_text u-hflex-between-center">
            <div className="hero_list_title u-text-small">{portfolio.title}</div>
          </div>
        </Link>
      </div>
    ));
  };


  return (
    <div data-barba-namespace="works" data-barba="container" className="page_wrap">
      {/* Hero Works Section */}
      <section data-horizontal-section="" className="hero_works_wrap u-overflow-clip">
        <div role="group" data-filter-group="" className="hero_works_contain">
          {/* Mobile Works Display */}
          <div className="hero_works_mobile">
            <div className="hero_works_collection is-mobile w-dyn-list">
              <div role="list" className="hero_works_list is-mobile w-dyn-items">
                {renderPortfolioItems(true)}
              </div>
            </div>
          </div>

          {/* Desktop Works Display */}
          <div className="hero_works_inner">
            <div data-horizontal-wrap="" className="hero_works_collection w-dyn-list">
              <div aria-live="polite" role="list" className="hero_works_list u-hflex-left-bottom w-dyn-items">
                {renderPortfolioItems()}
              </div>
            </div>
          </div>

          {/* Works Bottom Section */}
          <div className="works_bottom_wrap">
            <div className="works_bottom_contain">
              <div className="works_bottom_content">
                <h1 chars-reveal="" className="works_bottom_heading u-text-h2">Works</h1>
              </div>
            </div>
            <div className="works_bottom_scroll u-text-small">
              <div className="works_bottom_indicator">Scroll DOWN to explore</div>
              <div className="works_progress_contain">
                <div className="works_progress_brace">(</div>
                <div data-progress-nr="" className="progress-nr">00</div>
                <div className="works_progress_brace">%)</div>
              </div>
            </div>
            <div className="works_filter_wrap u-text-small">
              <div className="works_filter_contain">
                <Link data-link-hover="" to="/renders" className="g_link u-text-small w-inline-block">
                  <div className="g_link_contain">
                    <div data-link="black" className="g_link_text">In progress →</div>
                  </div>
                </Link>
              </div>
              <div className="works_filter_contain">
                <Link data-link-hover="" to="/archive" className="g_link u-text-small w-inline-block">
                  <div className="g_link_contain">
                    <div data-link="black" className="g_link_text">Archive →</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
    
  );
};

export default WorksPage;